export default "__VITE_ASSET__77a4ae48__"